import { FeatureFlag } from '@ps/web-core-enums';

import { Invoke } from '@swf/components/StarsWizard/Flow';

import { useFeature } from '../../../../../../libs/core/store/src/lib/hooks/useFeature';
import {
  EmailCode,
  EmailValidated,
  EmailVerification
} from '../components/EmailVerificationSteps/EmailVerificationSteps';

export const emailVerificationFlow = (invokeService: string) => {
  const hideEmailCode = useFeature(FeatureFlag.HideEmailConfirmationCode);
  const emailVerificationFlow = hideEmailCode
    ? [EmailVerification]
    : [
        EmailVerification,
        EmailCode,
        new Invoke(invokeService, EmailValidated, EmailCode),
        EmailValidated
      ];
  return emailVerificationFlow;
};
